export function splitDimensions(value) {
  // eslint-disable-next-line
  let [w, h, d] = String(value).split("x");
  if (w === "" || isNaN(w)) w = 0;
  if (h === "" || isNaN(h)) h = 0;
  if (d === "" || isNaN(d)) d = 0;
  return [w, h, d];
}

export function composeWidth(newW, value) {
  // eslint-disable-next-line
  let [w, h, d] = splitDimensions(value);
  return [newW, h, d].join("x");
}

export function composeHeight(newH, value) {
  // eslint-disable-next-line
  let [w, h, d] = splitDimensions(value);
  return [w, newH, d].join("x");
}

export function composeDepth(newD, value) {
  // eslint-disable-next-line
  let [w, h, d] = splitDimensions(value);
  return [w, h, newD].join("x");
}
